// extracted by mini-css-extract-plugin
module.exports = {"Featured":"Activity_Featured_Featured__11lvF","Image":"Activity_Featured_Image___QG8M"};